import React from 'react';
import PropTypes from 'prop-types';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import { LoadingButton } from '@mui/lab';
import Typography from '@mui/material/Typography';
import { Box, Dialog, FormHelperText, Grid, TextField } from '@mui/material';
import closeIcon from '../../../../assets/accountSetting-assets/x-circle.svg';
import { classes, AuthCardComponent } from './utils';

const DisplayNamePopUp = ({
  open,
  handleClose,
  displayName,
  setDisplayName,
  displayNameRequiredError,
  setDisplayNameRequiredError,
  addAccountHandler,
  selectedIcon,
}) => {
  const addDisplayNameHandler = async () => {
    if (!displayName || displayName.trim() === '') {
      setDisplayNameRequiredError('Display Name is required.*');
      return;
    }
    setDisplayNameRequiredError('');
    handleClose();
    sessionStorage.setItem('displayNameForCredential', displayName);
    await addAccountHandler(selectedIcon);
  };

  const handleOnChange = (e) => {
    setDisplayName(e.target.value);
    if (displayNameRequiredError) {
      setDisplayNameRequiredError('');
    }
  };

  return (
    <Dialog open={open}>
      <AuthCardComponent className={`${classes.cardComponent}`}>
        <CardHeader
          className={classes.cardHeader}
          title={
            <Grid container alignItems="center">
              <Grid item xs={10}>
                <Typography variant="h6">Add Display Name</Typography>
              </Grid>
              <Grid item xs={2} align="right">
                <Avatar
                  onClick={handleClose}
                  src={closeIcon}
                  className={classes.closeAction}
                />
              </Grid>
            </Grid>
          }
        />

        <CardContent className={classes.cardContent}>
          <Box display="flex" alignItems="center" justifyContent="end">
            <TextField
              required
              fullWidth
              size="small"
              name="displayName"
              label="Display Name"
              className={classes.GridItemTextfield}
              onChange={handleOnChange}
              value={displayName}
              error={!!displayNameRequiredError}
              // helperText={displayNameRequiredError}
            />
          </Box>
          <Box className={classes.displayNameErrorText}>
            {displayNameRequiredError && (
              <FormHelperText className={classes.formHelperText}>
                {displayNameRequiredError}
              </FormHelperText>
            )}
          </Box>

          <Box display="flex" justifyContent="end" alignItems="end" gap={1}>
            <LoadingButton
              variant="contained"
              alignItems="center"
              className={classes.exportButton}
              onClick={addDisplayNameHandler}
            >
              Add
            </LoadingButton>
          </Box>
        </CardContent>
      </AuthCardComponent>
    </Dialog>
  );
};

DisplayNamePopUp.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  displayName: PropTypes.string.isRequired,
  displayNameRequiredError: PropTypes.string.isRequired,
  selectedIcon: PropTypes.shape.isRequired,
  setDisplayName: PropTypes.func.isRequired,
  setDisplayNameRequiredError: PropTypes.func.isRequired,
  addAccountHandler: PropTypes.func.isRequired,
};

export default DisplayNamePopUp;
